module.exports = __webpack_public_path__ + "asset/image/deleteIcon-eb65.svg";